<template>
    <div class="preview" v-show="previewFlag">
      <div class="box">
        <img :src="filterImageUrl" width="400rem"  alt="图片加载失败">
        <div class="btn" @click="previewFlag=false"></div>
      </div>
    </div>
</template>
<script>

export default {
  data() {
    return {
      previewFlag: false,
      innerWidth: ''
    }
  },
  props:{
    value: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    filterImageUrl: function() {
      return this.imageUrl.includes('http') ? this.imageUrl : this.$server.qxyRes + this.imageUrl
    }
  },
  watch: {
    value: function() {
      this.previewFlag = this.value
    },
    previewFlag: function() {
      this.$emit('input', this.previewFlag)
    },
  },
  
}
</script>


<style scoped>
.preview{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
}
.box{
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.preview .btn{
  background: url('~@/assets/close.png') ;
  background-size: contain;
  margin-top: 30px;
  width: 100px;
  height: 100px;
  font-weight: bold;
}
</style>